import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';
import { AnimatePresence, m as lazyMotion, type Variants } from 'motion/react';

const BubbleContainer = styled(lazyMotion.div)(({ theme }) => ({
  display: 'flex',
  alignSelf: 'flex-start',
  backgroundColor: theme.palette.chat.bubble.scoopr.background,
  padding: theme.spacing(1.5),
  borderRadius: 8,
  boxShadow: '0px 1px 3px rgba(24, 160, 251, 0.12)',
  marginBottom: theme.spacing(1.5),
  width: '54px !important',
}));

const BubbleContent = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.chat.bubble.scoopr.text,
  fontSize: 14,
  lineHeight: '24px',
}));

const bounce = keyframes`
  0% {
    transform: scale(0.7);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const ThreeDotsContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  width: 30,
  height: 14,
});

const Dot = styled('div')(({ theme }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: theme.palette.chat.bubble.loading.default,
  animation: `${bounce} 0.4s infinite alternate ease-in-out`,
}));

const variants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: { ease: 'easeInOut' },
  },
  exit: {
    opacity: 0,
    transition: { ease: 'easeInOut', duration: 0.5 },
  },
} satisfies Variants;

const ThreeDots = () => (
  <ThreeDotsContainer>
    <Dot />
    <Dot style={{ animationDirection: 'alternate-reverse' }} />
    <Dot />
  </ThreeDotsContainer>
);

const LoadingBubble = ({ loading }: { loading: boolean }) => {
  return (
    <AnimatePresence mode="wait">
      {loading ? (
        <BubbleContainer
          key="loader"
          variants={variants}
          animate="visible"
          initial="hidden"
          exit="exit"
        >
          <BubbleContent>
            <ThreeDots />
          </BubbleContent>
        </BubbleContainer>
      ) : null}
    </AnimatePresence>
  );
};

export default LoadingBubble;
